import React, { Component } from 'react';

class IconSolutionGray extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="12.525" height="15.441" viewBox="0 0 12.525 15.441">
                <path id="Icon_metro-bookmark" data-name="Icon metro-bookmark" d="M8.355,1.928V17.369l6.262-4.825,6.262,4.825V1.928Z" transform="translate(-8.355 -1.928)" fill="#4e5b66" />
            </svg>

        );
    }
}

export default IconSolutionGray;